import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  createFeedback,
  fetchFeedbacks,
  fetchMyFeedbacks,
  fetchFeedbackAverage,
  fetchFeedbacksByRole,
  updateFeedback,
  deleteFeedback,
} from "../redux/thunks/adminThunks";

import {
  selectFeedbacks,
  selectFeedbackTotal,
  selectFeedbackAverage,
  selectFeedbackStatus,
  selectFeedbackError,
} from "../redux/selectors/adminSelectors";

export function useFeedback() {
  const dispatch = useDispatch();

  const feedbacks = useSelector(selectFeedbacks);
  const total = useSelector(selectFeedbackTotal);
  const average = useSelector(selectFeedbackAverage);
  const status = useSelector(selectFeedbackStatus);
  const error = useSelector(selectFeedbackError);

  const isLoading = status === "loading";

  const addFeedback = useCallback(
    async ({ rating, message }) => {
      return dispatch(createFeedback({ rating, message })).unwrap();
    },
    [dispatch]
  );

  const loadFeedbacks = useCallback(() => {
    return dispatch(fetchFeedbacks()).unwrap();
  }, [dispatch]);

  const loadMyFeedbacks = useCallback(() => {
    return dispatch(fetchMyFeedbacks()).unwrap();
  }, [dispatch]);

  const loadAverage = useCallback(() => {
    return dispatch(fetchFeedbackAverage()).unwrap();
  }, [dispatch]);

  const loadByRole = useCallback(
    (role) => {
      return dispatch(fetchFeedbacksByRole(role)).unwrap();
    },
    [dispatch]
  );

  const editFeedback = useCallback(
    async ({ id, rating, message }) => {
      return dispatch(updateFeedback({ id, rating, message })).unwrap();
    },
    [dispatch]
  );

  const removeFeedback = useCallback(
    async (id) => {
      return dispatch(deleteFeedback(id)).unwrap();
    },
    [dispatch]
  );

  return {
    feedbacks,
    total,
    average,
    status,
    error,
    isLoading,

    addFeedback,
    loadFeedbacks,
    loadMyFeedbacks,
    loadAverage,
    loadByRole,
    editFeedback,
    removeFeedback,
  };
}